
import Hub from './Hub'
import HydraIO from './HydraIO'
import HydraLock from './HydraLock'
import Sample from './Sample'
import ZWaveController from './ZWaveController'
import Egauge from './Egauge'

/* eslint-disable quote-props */

// Define a mapping of IOiceType to view class
export default {
  'hub': Hub,
  'hydra/io/v1': HydraIO,
  'hydra/lock/v1': HydraLock,
  'sample': Sample,
  'zwave/controller': ZWaveController,
  'egauge/EG4115': Egauge,
}

/* eslint-enable quote-props */
